/* eslint-disable react/jsx-props-no-spreading */

// utils
import { cn } from '@repo/zolintra-utils';

import { forwardRef } from 'react';
import styles from './Switch.module.css';

/**
 * `Switch` checkbox component with switch style.
 *
 * @typedef {Object} Props The properties for the `TextField` component.
 * @property {string} id The id of the text field, used for identification.
 * @property {string} [label] The label associated with the text field.
 * @property {boolean} [disabled=false] If `true`, the field will be disabled.
 * @property {string} [className] Additional CSS classes to apply to the component.
 * @property {import('react').ComponentPropsWithoutRef<"input">} [props.props]
 */

/**
 * @type React.ForwardRefExoticComponent<Props>
 */
export const Switch = forwardRef(({
  id, label, disabled, className, ...props
}, ref) => (
  <label htmlFor={id} className={cn([styles.wrapper, className])}>
    <div className={styles.switch} aria-label={label}>
      <input
        ref={ref}
        id={id}
        type="checkbox"
        className={styles.input}
        disabled={disabled}
        {...props}
      />
      <div className={styles.switchOuter}>
        <span className={styles.switchInner} />
      </div>
    </div>

    {label ? (
      <span className={styles.label}>{label}</span>
    ) : null}
  </label>
));

export default Switch;
